import script from "./CompactOrderTable.vue?vue&type=script&lang=ts"
export * from "./CompactOrderTable.vue?vue&type=script&lang=ts"

import "./CompactOrderTable.vue?vue&type=style&index=0&id=a6d71c6c&lang=css"
import "./CompactOrderTable.vue?vue&type=style&index=1&id=a6d71c6c&lang=css"

const __exports__ = script;

export default __exports__